<template>
  <div>
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="仪表列表" name="MeterList">
        <MeterList v-if="card_index==='MeterList'" />
      </el-tab-pane>
      <el-tab-pane v-if="(ERP.isPermission(4007002002)||ERP.isPermission(21004001002)||ERP.isPermission(8006001002))" label="批量导入" name="MeterImport">
        <MeterImport v-if="card_index==='MeterImport'" />
      </el-tab-pane>
      <el-tab-pane label="分析设置" name="MeterAmountTagImport">
        <MeterAmountTagImport v-if="card_index==='MeterAmountTagImport'" />
      </el-tab-pane>
      <el-tab-pane label="线路图" name="MeterMapList">
        <MeterMapList v-if="card_index==='MeterMapList'"/>
      </el-tab-pane>
      <el-tab-pane :label="user_type===2?'分摊模式':'计算模式'" name="MeterApportion">
        <MeterApportion v-if="card_index==='MeterApportion'" />
      </el-tab-pane>
      <el-tab-pane :label="user_type===2?'仪表分摊对象':'收费对象'" name="MeterApportionCustomerLayout">
        <MeterApportionCustomerLayout v-if="card_index==='MeterApportionCustomerLayout'" />
      </el-tab-pane>
<!--      <el-tab-pane label="收费对象列表" name="MeterApportionCustomerList">-->
<!--        <MeterApportionCustomerList v-if="card_index==='MeterApportionCustomerList'" />-->
<!--      </el-tab-pane>-->
      <el-tab-pane label="业主变更异动" name="MeterHouseCustomer">
        <MeterHouseCustomer v-if="card_index==='MeterHouseCustomer'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MeterList from "./MeterList";
import MeterImport from "./MeterImport";
import MeterMapList from "./MeterMapList";
import MeterApportion from "./MeterApportion";
import MeterApportionCustomerLayout from "./MeterApportionCustomerLayout";
import MeterAmountTagImport from "./MeterAmountTagImport";
import MeterHouseCustomer from "./MeterHouseCustomer";
import MeterApportionCustomerList from "./MeterApportionCustomerList";
export default {
  name: "MeterMain",
  components: {
    MeterApportionCustomerList,
    MeterHouseCustomer,
    MeterAmountTagImport, MeterApportionCustomerLayout, MeterApportion, MeterMapList, MeterImport, MeterList},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      card_index:"MeterList",
    }
  },
  activated() {
    if(this.$route.query.card_index){
      this.card_index=this.$route.query.card_index
    }
  },
  computed:{
    user_type(){
      return this.$route.query.type*1
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/MeterMain.vue